import React, { useState } from "react";
import { Button, Input, Modal } from "antd";
import ArbiratorImg from '../../assets/images/spotlight3.png'
import { Link } from "react-router-dom";
import SearchInput from "../../components/search_input";
import FilterSelect from "../../components/filter_select";
import { CiSearch } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import useGetAllData from "../../hooks/useGetAllData";
import useUrlQueryParams from "../../hooks/useUrlQeryParams";
import Icon1 from "../../assets/images/User.svg";
import Icon4 from "../../assets/images/kub.svg";
import Icon5 from "../../assets/images/location.svg";
import Icon6 from "../../assets/images/city.svg";
import { MdOutlineClear } from "react-icons/md";

const FindArbirators: React.FC = () => {
    const { t } = useTranslation()
    const [openModal, setopenModal] = useState<boolean>()
    const [searchVal, setSearchVal] = useState<string>("");
    const [allData, setallData] = useState([])

    const { urlValue, writeToUrl } = useUrlQueryParams({
        currentPage: 1,
        perPage: 10,
    });

    const options = [
        { label: 'Uzbekistan', value: 'Uzbekistan' },
        { label: 'Russia', value: 'Russia' },
        { label: 'USA', value: 'USA' },
        { label: 'India', value: 'India' },
    ];

    const showModal = () => {
        setopenModal(true);
    };

    const handleOk = () => {
        setopenModal(false);
    };

    const handleCancel = () => {
        setopenModal(false);
    };

    const { data, refetch, isLoading } = useGetAllData<any>({
        queryKey: ["arbitrators", urlValue.perPage, urlValue.currentPage, searchVal],
        url: "arbitrators",
        urlParams: { "perPage": urlValue.perPage, page: urlValue.currentPage, 'arbitrators': searchVal, },
        options: {
            refetchOnWindowFocus: false,
            retry: 1,
            onSuccess: (res: any) => {
                setallData(res?.items);
            },
        },
    });

    return (
        <>
            <div className="container mx-auto px-6">
                <div className="find_arbirators py-[20px]">
                    <h2 className="text-main_color font-bold text-4xl">Find arbitrators</h2>
                    <div className="lg:grid grid-cols-11 gap-4 mt-6 hidden">
                        <div className="col-span-3 max-sm:col-span-11 border-r-2 pr-4">
                            <div className='mb-3'>
                                <SearchInput duration={500} setSearchVal={setSearchVal} />
                            </div>
                            <FilterSelect
                                url={'arbitrators'}
                                name={'arbitrators'}
                                label={'arbitrators'}
                                permission={''}
                                onChange={(e) => {
                                    writeToUrl({ name: "arbitrators", value: e });
                                }}
                                value_name={'11'}
                                span={24}
                            />
                        </div>
                        <div className="col-span-3 max-sm:col-span-11 border-r-2 pr-4">
                            <div className='mb-3'>
                                <SearchInput duration={500} setSearchVal={setSearchVal} />
                            </div>
                            <FilterSelect
                                url={'arbitrators'}
                                name={'arbitrators'}
                                label={'arbitrators'}
                                permission={''}
                                value_name={'11'}
                                span={24}
                            />
                        </div>
                        <div className="col-span-3 max-sm:col-span-11 border-r-2 pr-4">
                            <div className='mb-3'>
                                <SearchInput duration={500} setSearchVal={setSearchVal} />
                            </div>
                            <FilterSelect
                                url={'arbitrators'}
                                name={'arbitrators'}
                                label={'arbitrators'}
                                permission={''}
                                value_name={'11'}
                                span={24}
                            />
                        </div>
                        <div className='col-span-2 max-sm:col-span-11'>
                            <Button htmlType='button' className='rounded-xl text-white text-center h-[44px] justify-center flex items-center bg-main_color w-full mb-3'><CiSearch size={24} color='white' className='mr-4' />{t('Search')}</Button>
                            <Button htmlType='button' className='rounded-xl text-center h-[44px] justify-center flex items-center w-full border-1 border-main_color'><IoClose size={24} color='#29487E' className='mr-4' />{t('Close')}</Button>
                        </div>
                    </div>
                    <div className="lg:hidden flex max-sm:flex-col gap-4 mt-6">
                        <div className="flex flex-col gap-4 sm:w-1/2 w-full">
                            <Input type="text" prefix={<img src={Icon1} width={15} className='mr-2' />} className="h-[44px] w-[100%] bg-[#F0F0F0]" placeholder="Name"></Input>
                            <Input type="text" prefix={<img src={Icon1} width={15} className='mr-2' />} className="h-[44px] w-[100%] bg-[#F0F0F0]" placeholder="Specialization"></Input>
                            <Input type="text" prefix={<img src={Icon1} width={15} className='mr-2' />} className="h-[44px] w-[100%] bg-[#F0F0F0]" placeholder="Language"></Input>
                            <Input type="text" prefix={<img src={Icon4} width={15} className='mr-2' />} className="h-[44px] w-[100%] bg-[#F0F0F0]" placeholder="Sphere"></Input>
                        </div>
                        <div className="w-[1px] bg-[#29487E3D] max-sm:hidden"></div>
                        <div className="flex flex-col gap-4 sm:w-1/2 w-full">
                            <Input type="text" prefix={<img src={Icon5} width={15} className='mr-2' />} className="h-[44px] w-[100%] bg-[#F0F0F0]" placeholder="Location"></Input>
                            <Input type="text" prefix={<img src={Icon6} width={15} className='mr-2' />} className="h-[44px] w-[100%] bg-[#F0F0F0]" placeholder="City"></Input>
                            <div className="flex sm:flex-col gap-4">
                                <button className="bg-main_color max-sm:w-1/2 text-white h-[44px] text-sm font-light flex items-center justify-center gap-1 rounded-md">
                                    <CiSearch size={18} /><span>Search</span>
                                </button>
                                <button className="border-main_color border max-sm:w-1/2 text-main_color h-[44px] text-sm font-light flex items-center justify-center gap-1 rounded-md">
                                    <MdOutlineClear size={18} /><span>Search</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <hr className="h-[2px] rounded bg-[#c5ddeb] my-12" />

                    <div className="grid grid-cols-12 gap-4">
                        <Link to={''} className="col-span-6 max-lg:col-span-12 py-4 px-5 hover:shadow-lg hover:shadow-[#A2C4D9] rounded-xl border border-solid border-[#29487E] bg-[#F6F6F6]" onClick={showModal}>
                            <div className="flex justify-between items-center sm:mb-3">
                                <div className="rounded bg-[#DBE9F2] text-center px-3 py-4 w-[200px] h-[90px]">
                                    <img src={ArbiratorImg} alt="arbirator image" className="w-[80%] h-[90%] block mx-auto" />
                                </div>
                                <div className="px-4">
                                    <h3 className="font-bold sm:text-xl text-sm">Dr. Hussam Sameer AI Talhuni</h3>
                                    <p className="font-semibold mb-3 sm:text-sm text-[9px]">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                    </p>
                                    <p className="text-main_color font-semibold sm:text-sm text-[9px]">United Arab Emirates, Dubai</p>
                                </div>
                            </div>
                            <span className="text-[#777777] sm:flex hidden items-center flex-wrap sm:text-xs gap-x-6 gap-y-2">
                                <span>
                                    Language: <span className="font-bold">UZ RU ENG</span>
                                </span>
                                <span>
                                    Specialization: <span className="font-bold mr-6">Specialization</span>
                                </span>
                            </span>
                        </Link>
                        <Link to={''} className="col-span-6 max-lg:col-span-12 py-4 px-5 hover:shadow-lg hover:shadow-[#A2C4D9] rounded-xl border border-solid border-[#29487E] bg-[#F6F6F6]" onClick={showModal}>
                            <div className="flex justify-between items-center sm:mb-3">
                                <div className="rounded bg-[#DBE9F2] text-center px-3 py-4 w-[200px] h-[90px]">
                                    <img src={ArbiratorImg} alt="arbirator image" className="w-[80%] h-[90%] block mx-auto" />
                                </div>
                                <div className="px-4">
                                    <h3 className="font-bold sm:text-xl text-sm">Dr. Hussam Sameer AI Talhuni</h3>
                                    <p className="font-semibold mb-3 sm:text-sm text-[9px]">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                    </p>
                                    <p className="text-main_color font-semibold sm:text-sm text-[9px]">United Arab Emirates, Dubai</p>
                                </div>
                            </div>
                            <span className="text-[#777777] sm:flex hidden items-center flex-wrap sm:text-xs gap-x-6 gap-y-2">
                                <span>
                                    Language: <span className="font-bold">UZ RU ENG</span>
                                </span>
                                <span>
                                    Specialization: <span className="font-bold mr-6">Specialization</span>
                                </span>
                            </span>
                        </Link>
                        <Link to={''} className="col-span-6 max-lg:col-span-12 py-4 px-5 hover:shadow-lg hover:shadow-[#A2C4D9] rounded-xl border border-solid border-[#29487E] bg-[#F6F6F6]" onClick={showModal}>
                            <div className="flex justify-between items-center sm:mb-3">
                                <div className="rounded bg-[#DBE9F2] text-center px-3 py-4 w-[200px] h-[90px]">
                                    <img src={ArbiratorImg} alt="arbirator image" className="w-[80%] h-[90%] block mx-auto" />
                                </div>
                                <div className="px-4">
                                    <h3 className="font-bold sm:text-xl text-sm">Dr. Hussam Sameer AI Talhuni</h3>
                                    <p className="font-semibold mb-3 sm:text-sm text-[9px]">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                    </p>
                                    <p className="text-main_color font-semibold sm:text-sm text-[9px]">United Arab Emirates, Dubai</p>
                                </div>
                            </div>
                            <span className="text-[#777777] sm:flex hidden items-center flex-wrap sm:text-xs gap-x-6 gap-y-2">
                                <span>
                                    Language: <span className="font-bold">UZ RU ENG</span>
                                </span>
                                <span>
                                    Specialization: <span className="font-bold mr-6">Specialization</span>
                                </span>
                            </span>
                        </Link>
                        <Link to={''} className="col-span-6 max-lg:col-span-12 py-4 px-5 hover:shadow-lg hover:shadow-[#A2C4D9] rounded-xl border border-solid border-[#29487E] bg-[#F6F6F6]" onClick={showModal}>
                            <div className="flex justify-between items-center sm:mb-3">
                                <div className="rounded bg-[#DBE9F2] text-center px-3 py-4 w-[200px] h-[90px]">
                                    <img src={ArbiratorImg} alt="arbirator image" className="w-[80%] h-[90%] block mx-auto" />
                                </div>
                                <div className="px-4">
                                    <h3 className="font-bold sm:text-xl text-sm">Dr. Hussam Sameer AI Talhuni</h3>
                                    <p className="font-semibold mb-3 sm:text-sm text-[9px]">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                    </p>
                                    <p className="text-main_color font-semibold sm:text-sm text-[9px]">United Arab Emirates, Dubai</p>
                                </div>
                            </div>
                            <span className="text-[#777777] sm:flex hidden items-center flex-wrap sm:text-xs gap-x-6 gap-y-2">
                                <span>
                                    Language: <span className="font-bold">UZ RU ENG</span>
                                </span>
                                <span>
                                    Specialization: <span className="font-bold mr-6">Specialization</span>
                                </span>
                            </span>
                        </Link>
                        <Link to={''} className="col-span-6 max-lg:col-span-12 py-4 px-5 hover:shadow-lg hover:shadow-[#A2C4D9] rounded-xl border border-solid border-[#29487E] bg-[#F6F6F6]" onClick={showModal}>
                            <div className="flex justify-between items-center sm:mb-3">
                                <div className="rounded bg-[#DBE9F2] text-center px-3 py-4 w-[200px] h-[90px]">
                                    <img src={ArbiratorImg} alt="arbirator image" className="w-[80%] h-[90%] block mx-auto" />
                                </div>
                                <div className="px-4">
                                    <h3 className="font-bold sm:text-xl text-sm">Dr. Hussam Sameer AI Talhuni</h3>
                                    <p className="font-semibold mb-3 sm:text-sm text-[9px]">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                    </p>
                                    <p className="text-main_color font-semibold sm:text-sm text-[9px]">United Arab Emirates, Dubai</p>
                                </div>
                            </div>
                            <span className="text-[#777777] sm:flex hidden items-center flex-wrap sm:text-xs gap-x-6 gap-y-2">
                                <span>
                                    Language: <span className="font-bold">UZ RU ENG</span>
                                </span>
                                <span>
                                    Specialization: <span className="font-bold mr-6">Specialization</span>
                                </span>
                            </span>
                        </Link>
                        <Link to={''} className="col-span-6 max-lg:col-span-12 py-4 px-5 hover:shadow-lg hover:shadow-[#A2C4D9] rounded-xl border border-solid border-[#29487E] bg-[#F6F6F6]" onClick={showModal}>
                            <div className="flex justify-between items-center sm:mb-3">
                                <div className="rounded bg-[#DBE9F2] text-center px-3 py-4 w-[200px] h-[90px]">
                                    <img src={ArbiratorImg} alt="arbirator image" className="w-[80%] h-[90%] block mx-auto" />
                                </div>
                                <div className="px-4">
                                    <h3 className="font-bold sm:text-xl text-sm">Dr. Hussam Sameer AI Talhuni</h3>
                                    <p className="font-semibold mb-3 sm:text-sm text-[9px]">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting industry
                                    </p>
                                    <p className="text-main_color font-semibold sm:text-sm text-[9px]">United Arab Emirates, Dubai</p>
                                </div>
                            </div>
                            <span className="text-[#777777] sm:flex hidden items-center flex-wrap sm:text-xs gap-x-6 gap-y-2">
                                <span>
                                    Language: <span className="font-bold">UZ RU ENG</span>
                                </span>
                                <span>
                                    Specialization: <span className="font-bold mr-6">Specialization</span>
                                </span>
                            </span>
                        </Link>
                    </div>

                    <div className="mt-8">
                        {/* <CustomPagination
                            totalCount={data["hydra:totalItems"]}
                            currentPage={urlValue.currentPage}
                            perPage={urlValue.perPage}
                        /> */}
                    </div>
                </div>
            </div>


            <Modal title="Arbirators View" open={openModal} onOk={handleOk} onCancel={handleCancel} className="w-[700px]" centered footer>
                <div>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam, ipsa deleniti dicta quis ipsum omnis optio, rerum impedit debitis id error voluptatem facilis. Praesentium natus vitae sit cupiditate reprehenderit magnam, debitis quae sapiente non accusantium quisquam voluptatum itaque architecto pariatur in, voluptates earum quas nulla! Incidunt error alias fuga. Perferendis?
                    </p>
                    <Button className="ml-auto block mt-5 bg-main_color text-white text-base font-semibold text-center px-5 w-[150px] h-[40px]">Voiting</Button>
                </div>
            </Modal>
        </>
    )
}

export default FindArbirators